
const BTBox = ({ 
    width = '10px', 
    height = '10px', 
    backgroundColor = 'transparent', 
    margin = '0'  // margin 기본값을 0으로 설정
  }) => {
    return (
      <div
        style={{
          width: width,
          height: height,
          backgroundColor: backgroundColor,
          flexShrink: 0,
          margin: margin,  // margin 스타일을 추가
        }}
      ></div>
    );
  };

export default BTBox;